import React from 'react';
import styled, { css } from 'styled-components';
import theme from '~/purchase-ui/src/components/base/theme';

const RadioInput = styled.input`
  appearance: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 2px solid var(--colors-neutral-gray-3);
  display: grid;
  place-content: center;
  cursor: pointer;

  &::before {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--colors-primary-blue-2);
  }

  &:checked {
    border-color: var(--colors-primary-blue-2);
  }

  &:hover {
    border-color: var(--colors-primary-blue-3);
  }

  &:disabled {
    border-color: var(--colors-neutral-gray-2);
    cursor: not-allowed;
  }

  &:checked::before {
    transform: scale(1);
  }

  &:disabled::before {
    box-shadow: inset 1em 1em var(--colors-neutral-gray-2);
    transform: scale(0);
  }
`;

const Label = styled.label<{
  isDisabled: boolean;
  useNormalFontWeight: boolean;
}>`
  color: var(--colors-primary-blue-6);
  ${props =>
    !props.useNormalFontWeight &&
    css`
      ${theme.font.header.s};
    `}
  ${props =>
    props.useNormalFontWeight &&
    css`
      ${theme.font.body.m};
    `}
  display: grid;
  grid-template-columns: 24px auto;
  gap: 8px;
  cursor: pointer;
  align-items: center;

  ${props => props.isDisabled && 'opacity: 0.3; cursor: not-allowed;'}
`;

const defaultProps = {
  text: null as null | string
};

const optionalProps = {
  useNormalFontWeight: false
};

const Radio: React.FC<
  React.ComponentProps<typeof RadioInput> &
    typeof defaultProps &
    Partial<typeof optionalProps>
> = props => {
  const { disabled, text, useNormalFontWeight = false } = props;
  return (
    <Label isDisabled={disabled} useNormalFontWeight={useNormalFontWeight}>
      <RadioInput type="radio" {...props} />
      {text}
    </Label>
  );
};

export default Radio;
